import {
    STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getBranchOfficesDataMaster(carLotId, branchOfficeId = null) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_BEGIN,
        data: { carLotId, branchOfficeId }
      })
    }
  }